import { getData } from "../Config/AxiosConfig"

export const getAnalyticsOverview = async (id, filter) => {
    return await getData(
        `analytics-overview/${id}${filter ? `?filter=${filter}` : ""}`
    );
};

export const getOrdersOverview = async (id, filter) => {
    return await getData(
        `analytics-order/${id}${filter ? `?filter=${filter}` : ""}`
    );
};